import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IColumn, IObjectMapInfo } from "../../services/data-file-import-data-service/Models";
import DataFileImportDataService from "../../services/data-file-import-data-service/DataFileImportDataService";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export type UseDataFileImportObjectMapParams = {
    groupID: number;
    fileName: string;
    fileHasHeaderRow: boolean;
    identifierColumn: IColumn
    importObjectType: eLynxObjectTypeEnum

} & BaseUseQueryParameters<IObjectMapInfo>;

export function useDataFileImportObjectMap({
    groupID,
    fileName,
    fileHasHeaderRow,
    identifierColumn,
    importObjectType,
    enabled,    
    onSuccess,
    onError
}: UseDataFileImportObjectMapParams) {
    return useQuery<IObjectMapInfo, RestError>(
        keys.objectMap(groupID,
            fileName,
            fileHasHeaderRow,
            identifierColumn,
            importObjectType),
        ({ signal }) => {
            return DataFileImportDataService.configGetCsvObjectMap(groupID, {
                fileName,
                fileHasHeaderRow,
                identifierColumn,
                importObjectType
            },
            signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            // refetchInterval: false,
            // staleTime: Infinity,
            // refetchOnWindowFocus: false,
            // refetchOnMount: true,
            // refetchOnReconnect: false,
            // retry: false,
        }
    );
}